import styled from "styled-components";
import { MediaQuery } from "../../hooks/useDeviceType";
import {
  GAINSBORO,
  LIGHT_EERIE_BLACK,
  PRIMARY_FONT,
  PRIMARY_SIZE,
  SECONDARY_FONT,
  SLIM_WEIGHT,
  SMALL_SECONDARY_SIZE,
  SMALL_TITLE_SIZE,
} from "../../utils/variables";

export const Container = styled.section`
  max-width: 110rem;
  margin: 0 auto;
  padding: 2rem 6rem 10rem;

  svg {
    height: 4rem;
    width: 4rem;
  }

  @media ${MediaQuery.isMobile} {
    padding: 2rem 2rem 6rem;
  }
`;

export const Heading = styled.h2`
  margin-left: 1rem;
  font-family: ${PRIMARY_FONT};
  font-size: ${SMALL_TITLE_SIZE};
  white-space: nowrap;
  text-align: center;
  margin-bottom: 4rem;
`;

export const Description = styled.div``;

export const Subheading = styled.h3`
  font-family: ${PRIMARY_FONT};
  font-size: ${PRIMARY_SIZE};
  margin-top: 1.4rem;
  margin-bottom: 1rem;
`;

export const Skill = styled.li`
  white-space: nowrap;
  font-family: ${SECONDARY_FONT};
  font-size: 1.2rem;
  line-height: 1.6rem;
  opacity: 0.55;
  padding: 0.5rem 0.9rem;
  border: 1px solid rgba(218, 221, 216, 0.2);
  border-radius: 999px;

  @media ${MediaQuery.isMobile} {
    padding: 0.35rem 0.55rem;
    font-size: 1.2rem;
    line-height: 1.4rem;
  }
`;

export const Stack = styled.ul`
  list-style-type: none;
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  align-content: flex-start;

  @media ${MediaQuery.isMobile} {
    gap: 0.4rem;
  }
`;

export const ProjectsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export const Project = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem;
  min-height: 30rem;
  max-width: 30rem;
  margin: 1rem;
  background-color: ${LIGHT_EERIE_BLACK};
  border: 1px solid rgba(238, 240, 242, 0.08);
  border-radius: 0.8rem;
  box-shadow: 0 1.8rem 4rem rgba(0, 0, 0, 0.24);
`;

export const Text = styled.p`
  color: ${GAINSBORO};
  font-weight: ${SLIM_WEIGHT};
  font-size: ${SMALL_SECONDARY_SIZE};
  line-height: 2.3rem;
`;
